import { supabase } from '@/lib/supabase';
import type {
  AreasInsert,
  AreasRow,
  AreasUpdate,
} from '@/types/database.types';

export async function listAreas(): Promise<AreasRow[]> {
  const { data, error } = await supabase
    .from('areas')
    .select('*')
    .order('sort_order', { ascending: true })
    .order('name', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function createArea(input: AreasInsert): Promise<AreasRow> {
  const { data, error } = await supabase
    .from('areas')
    .insert(input)
    .select('*')
    .single();
  if (error) throw error;
  return data;
}

export async function updateArea(
  id: string,
  patch: AreasUpdate,
): Promise<AreasRow> {
  const { data, error } = await supabase
    .from('areas')
    .update(patch)
    .eq('id', id)
    .select('*')
    .single();
  if (error) throw error;
  return data;
}

export async function deleteArea(id: string): Promise<void> {
  const { error } = await supabase.from('areas').delete().eq('id', id);
  if (error) throw error;
}
